import React, { Component,PropTypes } from 'react';
import { Link } from "react-router";
import {ellaUrl} from '../../path.config'

import {getUserId,resultTip,successShow,errorShow,language,errToSuc} from "UTIL/common"
import roleService from 'SERVICES/ella/roleService'
import FormInput from 'CONFIG/component/form/formInput'
import Tip from 'CONFIG/component/tip'
import BoxHeader from "CONFIG/component/boxHeaderCreate"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import ErrorSpan from 'COMPONENT/errorSpan'
export default class RoleAdd extends Component {
	constructor(props) {
		super(props);
		this.btnSubmit = this.btnSubmit.bind(this);
		this.state = {
			nodeVos:[],
			url:ellaUrl
		};
	}
	componentDidMount() {
		const userId = getUserId();
		roleService.roleToAdd(getUserId(userId)).then(data=>{
            var nodeVos = JSON.parse(data.data.nodeVos);
            this.setState({
                nodeVos : nodeVos,
            })
            var setting = {
                check: {
                    enable: true
                },
                showLine: true,
                callback: {
                    onCheck: this.onChange.bind(this),
                }
            };
            $.fn.zTree.init($("#pageTree"), setting, nodeVos);
		})
	}
	btnSubmit(event){
		errToSuc();
		event.preventDefault();
		var roleName = $("#roleName").val();
		var roleNumber = $("#roleNumber").val();
        var remark = $("#remark").val();
        var zTree = $.fn.zTree.getZTreeObj("pageTree");
        var Nodes = zTree.getCheckedNodes(true);
        var filterNodes = Nodes.filter(function(el,index){
            return el.children == null;
        });
        var permissions = filterNodes.map(function(data){
            return data.id+"_"+data.level;
        });
        var arr = {
            roleName:roleName,
            roleNumber:roleNumber,
            remark:remark,
            permissions:String(permissions),
            userId:sessionStorage.userId,
        };
        if(roleName == ''){
            errorShow('roleName');
        }
        if(roleNumber == ''){
            errorShow('roleNumber');
        }
        if(permissions ==''){
            errorShow('pageTree');
		}
        if($("[name='error']").length == 0){
            $("#btnSubmit").attr('disabled','true')

            const data = JSON.stringify(arr);
            roleService.roleDoAddOrUpdate({data}).then(body=>{
                resultTip(body,'/ella/role/roleIndex');
            });
		}

	}
	onChange(event, treeId, treeNode){
        successShow('pageTree');
	}
	render() {
		return (
			<div >
				<ContentHeader nameLg={'roleManagement'} nameSm="addRole" />
			    <section className="content" >
					<div className="box box-primary color-palette-box">
						<BoxHeader name={language()['addRole']}/>
						<div className="box-body">
							<Tip ids=""/>
							<form className="form-horizontal">
								<FormInput id="roleName" name="roleName"/>
								<FormInput id="roleNumber" name="roleNo"/>
								<div className="row form-group">
									<label  className="multi-label control-label col-xs-2">{language()['remark']}</label>
									<div className="col-xs-3">
										<textarea className="form-control" rows="3" id="remark" ></textarea>
									</div>
								</div>
								<div className="row form-group">
									<label  className="multi-label control-label col-xs-2">{language()['AuthorityAssignment']}</label>
									<div id="leftTree" className="col-xs-3 " >
										<ul id="pageTree" className="ztree" style={{width:'100%'}}>

										</ul>
									</div>
									<ErrorSpan id="pageTree"/>
								</div>
								<div className="row form-group">
									<div className="col-xs-2"></div>
									<div className="col-xs-1 text-center">
										<Link  to = "/ella/role/roleIndex" className="btn btn-default btn-md">
											{language()['return']}
										</Link>
									</div>
									<div className="col-xs-1 text-center">
										<button className="btn btn-success" id="btnSubmit" onClick={this.btnSubmit.bind(this)}>{language()['submit']}</button>
									</div>

								</div>
							</form>
						</div>
					</div>
				</section>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/ella/role/roleAdd.js